import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Logout from "@mui/icons-material/Logout";
import KeyIcon from "@mui/icons-material/Key";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import ComponentPopup from "./ComponentPopup";
import { useState } from "react";
import Divider from "@mui/material/Divider";
import ChangePassword from "../LoginUser/ChangePassword";

export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPassword, setOpenPassword] = useState(false);
  const open = Boolean(anchorEl);
  const { setUserInfo, userInfo } = useAuth();
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPassword = () => {
    setAnchorEl(null);
    setOpenPassword(true);
  };

  const handleClosePassword = () => {
    setOpenPassword(false);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    setUserInfo({});
    localStorage.removeItem("user_info");
    localStorage.removeItem("token");
    setAnchorEl(null);
    navigate(`/login`);
  };

  const MENU_ITEMS = [
    {
      label: "Change Password",
      onClick: handleOpenPassword,
      icon: <KeyIcon fontSize="small" />,
    },
    {
      label: "Logout",
      onClick: handleLogout,
      icon: <Logout fontSize="small" />,
    },
  ];

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{
            ml: 2,
            "&:hover": {
              backgroundColor: "rgba(1, 40, 95, 0.08)",
            },
          }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <Avatar
            sx={{
              width: 40,
              height: 40,
              background: "linear-gradient(135deg, #01285f 0%, #023a7a 100%)",
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(1, 40, 95, 0.3)",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0 4px 12px rgba(1, 40, 95, 0.4)",
              },
            }}
          >
            {userInfo.first_name?.[0]?.toUpperCase() || "A"}
          </Avatar>
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 4px 16px rgba(1, 40, 95, 0.15))",
              mt: 1.5,
              borderRadius: 2,
              border: "1px solid rgba(1, 40, 95, 0.1)",
              minWidth: 200,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "& .MuiMenuItem-root": {
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "rgba(1, 40, 95, 0.08)",
                },
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
                borderLeft: "1px solid rgba(1, 40, 95, 0.1)",
                borderTop: "1px solid rgba(1, 40, 95, 0.1)",
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <div className="px-3 py-2">
          <h5 className="account-name">
            {[userInfo.first_name, userInfo.middle_name, userInfo.last_name]
              .filter(Boolean)
              .join(" ")}
          </h5>

          <span>{userInfo.email}</span>
        </div>
        <Divider />
        {MENU_ITEMS.map((item) => (
          <MenuItem key={item.label} onClick={item.onClick}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
      <ComponentPopup
        openPopup={openPassword}
        setOpenPopup={setOpenPassword}
        title="Change Password"
        componentToPassDown={
          <ChangePassword handleClose={handleClosePassword} />
        }
      />
    </>
  );
}
